import { useLocation } from 'react-router-dom'

/** Get the tenant ID from the URL (eg "/t/123/some-page" -> "123") */
export function useTenantId() {
  const { pathname } = useLocation()
  return pathname.match(/^\/t\/(\d+)(\/|$)/)?.[1] ?? undefined
}
